import React, { useState } from "react";

export default function DealDemo(props) {
  const item = props.mapdata;
  const [showrow, setshowrow] = useState(0);
  const filterRow = (rownumber) => {
    let newval = showrow !== rownumber ? rownumber : 0;
    setshowrow(newval);
  };
  return (
    <>
      <tr>
        <td>{item.symbol} </td>
        <td>{item.ltp} </td>
        <td>{item.signal}</td>
        <td style={{ color: item.color }}>{item.cp}</td>
        <td className="text-center">
          <button
            className="btn btm-sm btn-info"
            title="View More Details"
            onClick={(event) => filterRow(item.bulk_deal_id)}
          >
            <i className="info-link fa fa-info"></i>
          </button>{" "}
        </td>
      </tr>
      {showrow === item.bulk_deal_id && (
        <tr>
          <td colSpan="4">
            {item.child
              ? item.child.map((client, ckey) => (
                  <div className="table-row" key={ckey}>
                    <div className="lebel">
                      {" "}
                      Client Name :{" "}
                      <span className="text-value">{client.ClientName}</span>
                    </div>
                    <div className="lebel">
                      {" "}
                      Action :{" "}
                      <span className="text-value">{client.action} </span> Trade
                      Price :{" "}
                      <span className="text-value">{client.TradePrice} </span>{" "}
                      Qty :
                      <span className="text-value">
                        {client.QuantityTraded}{" "}
                      </span>{" "}
                    </div>
                  </div>
                ))
              : ""}
          </td>
        </tr>
      )}
    </>
  );
}
